import { FC, ReactElement } from 'react'

import { Slot } from '@radix-ui/react-slot'
import { twMerge } from 'tailwind-merge'

import { TextProps } from './types'

export const Text: FC<TextProps> = ({ children, asChild, className, ...props }): ReactElement => {
  const allProps = {
    ...props,
    className: twMerge('antialiased', className),
  }

  return asChild ? <Slot {...allProps}>{children}</Slot> : <span {...allProps}>{children}</span>
}

Text.displayName = 'Text'
